import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../react-oe/oe-interface-adapter';
import retardUpdate from '../../lib/react/update-retarder';

export default class OEBGLoadingDisplay extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.show = false;
        this.progress = 100.0;
        this.timer = null;

        this.state = {
            show: this.show,
            progress: this.progress,
            strings:   {
                message: ''
            },
            tick: 0
        };

        this.updateLanguage = this.updateLanguage.bind(this);
        this.onFetchProgress = this.onFetchProgress.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.fetchProgress, this.onFetchProgress);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.fetchProgress, this.onFetchProgress);
    }

    tick() {
        this.setState((prevState, props) => {
            let newState = clone(prevState);
            newState.tick = (prevState.tick + 1) % 4; 
            return newState;
        });
    }

    startTimer() {
        if(this.timer) return;
        this.timer = setInterval(this.tick.bind(this), 330);
    }

    stopTimer() {
        if(!this.timer) return;
        clearInterval(this.timer);
        this.timer = null;
    }

    updateLanguage()   {
        this.setState({strings: {
            message: this.oe.sharedInterface.getLocalizedStringEnc('texture_loading_display')
        }});
    }

    onFetchProgress(message, userInfo)   {
        const progress = userInfo.progress;
        const show = progress >= 0 && progress < 100; // progress of -1 is signalling a problem
        if(progress === this.progress && show === this.show) return;
        this.show = show;
        this.progress = progress;
    
        retardUpdate(this, () => {
            if(show) {
                this.startTimer();
            } else {
                this.setState({tick: 0});
                this.stopTimer();
            }

            this.setState({
                show: this.show,
                progress: this.progress,
            });
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.show = false;
            this.setState({show: this.show});
            return;
        }
        
        retardUpdate(this, () => {
            this.updateLanguage();
        });
    }

    render() {
        let show = this.props.show && this.state.show;

        let tickString = '', fillerTickString = '';
        if(show)    {
            for(let i = 0; i < this.state.tick; ++i) tickString = tickString + '. ';
            for(let i = this.state.tick; i < 4; ++i) fillerTickString = fillerTickString + '. ';
        }

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                {!show ? null :
                    <div className = {'bg-loading-display view-port-label-text-color-border ' + this.props.className}>
                        <span>{this.state.strings.message + ' ' + tickString}</span><span className="opacity-0">{fillerTickString}</span>
                        <div className="bg-loading-display-progress-bar">
                            <div className="bg-loading-display-progress-bar-inner view-port-label-text-color-bg-border" style={{width: String(this.state.progress)+'%'}}></div>
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    }
}

OEBGLoadingDisplay.defaultProps = {
    className: '',
    moduleId: '',
    show: true
};

OEBGLoadingDisplay.propTypes = {
    className: PropTypes.string,
    moduleId: PropTypes.string,
    show: PropTypes.bool
};